import { render } from "./App.vue?vue&type=template&id=53989388"
const script = {}

import "./App.vue?vue&type=style&index=0&id=53989388&lang=css"

import exportComponent from "/DATA/REPO/landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__